@let item1Image = data.items[0]?.image!;
@let item2Image = data.items[1]?.image!;
@let item3Image = data.items[2]?.image!;
@let item4Image = data.items[3]?.image!;
@let item5Text = data.items[4]?.text!;
@let item6Image = data.items[5]?.image!;
@let item7Video = data.items[6]?.video!;

<div class="centered-with-padding mx-auto py-7">
  <div class="flex flex-col gap-y-5 desk:gap-y-4">
    @if (data.title; as title) {
      <app-title [title]="title" size="h2" />
    }

    @if (data.description; as description) {
      <span>{{ description }}</span>
    }
  </div>
  <div class="grid grid-cols-2 gap-1 pt-7 desk:grid-cols-6 desk:gap-4">
    <div
      class="group row-span-2 h-[300px] overflow-hidden rounded-3xl desk:order-1 desk:col-span-3 desk:row-span-full desk:aspect-square desk:h-auto">
      @if (item1Image) {
        <app-image
          class="cursor-zoom-in"
          (click)="zoomImageRequested.emit(item1Image)"
          [hoverEffect]="true"
          [image]="item1Image"
          [isPriority]="!isImageInPreviousBlocks"
          [pregenerationSize]="{ width: 532, height: 532, exact: 'desk' }" />
      }
    </div>

    <div
      class="group row-span-2 h-[300px] overflow-hidden rounded-3xl desk:order-2 desk:col-span-3 desk:row-span-full desk:aspect-square desk:h-auto">
      @if (item2Image) {
        <app-image
          class="cursor-zoom-in"
          (click)="zoomImageRequested.emit(item2Image)"
          [hoverEffect]="true"
          [image]="item2Image"
          [isPriority]="!isImageInPreviousBlocks"
          [pregenerationSize]="{ width: 532, height: 532, exact: 'desk' }" />
      }
    </div>

    <div
      class="group row-span-2 h-[300px] overflow-hidden rounded-3xl desk:order-3 desk:col-span-2 desk:row-span-1 desk:aspect-square desk:h-auto">
      @if (item3Image) {
        <app-image
          class="cursor-zoom-in"
          (click)="zoomImageRequested.emit(item3Image)"
          [hoverEffect]="true"
          [image]="item3Image"
          [pregenerationSize]="{ width: 349, height: 349, exact: 'desk' }" />
      }
    </div>

    <div
      class="group h-[calc(150px-.125rem)] overflow-hidden rounded-3xl desk:order-5 desk:col-span-2 desk:row-span-1 desk:aspect-square desk:h-auto">
      @if (item4Image) {
        <app-image
          class="cursor-zoom-in"
          (click)="zoomImageRequested.emit(item4Image)"
          [hoverEffect]="true"
          [image]="item4Image"
          [pregenerationSize]="{ width: 349, height: 349, exact: 'desk' }" />
      }
    </div>

    <div
      class="flex h-[calc(150px-.125rem)] flex-col justify-center gap-2 rounded-3xl bg-anis p-6 text-center desk:order-4 desk:col-span-2 desk:row-span-1 desk:aspect-square desk:h-auto desk:gap-9">
      @if (item5Text?.title; as title) {
        <app-title [title]="title" size="custom-15" />
      }
      @if (item5Text?.subtitle; as subtitle) {
        <span class="text-[10px] font-bold leading-[14px] desk:text-[14px] desk:leading-[19px]">{{ subtitle }}</span>
      }
    </div>

    @if (!data.hideLastItem) {
      <div class="group row-span-2 h-[300px] overflow-hidden rounded-3xl desk:order-6 desk:col-span-4 desk:h-[531px]">
        @if (item6Image) {
          <app-image
            class="cursor-zoom-in"
            (click)="zoomImageRequested.emit(item6Image)"
            [hoverEffect]="true"
            [image]="item6Image"
            [pregenerationSize]="{ width: 715, height: 531, exact: 'desk' }" />
        }
      </div>
      <div class="row-span-2 h-[300px] overflow-hidden rounded-3xl desk:order-7 desk:col-span-2 desk:h-[531px]">
        @if (item7Video) {
          <app-video
            [autoplay]="true"
            [posterPregenerationSize]="{ width: 349, height: 531, exact: 'desk' }"
            [video]="item7Video" />
        }
      </div>
    }
  </div>
</div>
